import { sendGTMEvent } from '@next/third-parties/google'

import { IStorageData } from '@/types'
import { filterFees } from './misc'

export const registerEvent = (
  event: 'purchase' | 'refund',
  data?: IStorageData,
) => {
  if (!data) return
  const { customer, totalCharge, fees, pricedEquips, pricedCoverages, confId } =
    data.reservation
  sendGTMEvent({
    event,
    ecommerce: {
      pickupLocation: data.location_info.pickUpLocation,
      user: {
        email: data.email,
        name: `${customer.givenName ?? ''} ${customer.surname ?? ''}`,
      },
      transaction_id: confId.id,
      currency: totalCharge.currencyCode,
      value: +totalCharge.estimatedTotalAmount.replaceAll(/[,]/g, ''),
      tax: fees
        .filter(filterFees)
        .reduce((acc, cur) => acc + +cur.amount.replaceAll(/[,]/g, ''), 0),
      items: [
        ...pricedEquips
          .filter(_v => parseInt(_v.charge.amount) !== 0)
          .map(_v => ({
            item_id: _v.equipment.equipType,
            item_name: _v.equipment.description,
            price: +_v.charge.amount.replaceAll(/[,]/g, ''),
            quantity: +_v.equipment.quantity.replaceAll(/[,]/g, ''),
          })),
        ...pricedCoverages
          .filter(_v => parseInt(_v.calculation.total) !== 0)
          .map(_v => ({
            item_name: _v.details,
            item_id: _v.coverageType,
            quantity: +_v.calculation.quantity.replaceAll(/[,]/g, ''),
            price: +_v.calculation.unitCharge.replaceAll(/[,]/g, ''),
          })),
      ],
    },
  })
}
